import axios from 'axios'
import { useQuery } from 'react-query'
import { API_BASE_URI, ENV } from '../config'

export const useGeolocationCountry = () =>
  useQuery<string | null>({
    queryKey: ['geolocation'],
    queryFn: async () => {
      try {
        const {
          data: { country },
        } = await axios(`${API_BASE_URI}/geolocation.json`)
        return country
      } catch (error) {
        return null
      }
    },
    staleTime: Infinity,
    enabled: ENV !== 'local',
  })
